export default {
    alignToolbar: {
        algnLeft: 'Left alignment',
        algnCenter: 'Center horizontally',
        algnRight: 'Right alignment',
        alginTop: 'Top alignment',
        alginVertical: 'Center vertically',
        alginBottom: 'Bottom alignment',
        vertical: 'Vertical',
        horizontal: 'Horizontal',
        relativeCanvas: 'To canvas',
        betweenEl: 'Between elements',
        typesetting: 'Layout',
    },
    baseLayer: {
        imageLayerAiItem: {
            aIExpendImage: 'AI Image Extender',
            aIModifyImage: 'Modify',
            aiTextMaterial: 'AI Calligraphy',
        },
        shortcutOperate: {
            unGroup: 'Ungroup',
            unSupportGroup: 'Ungroup not supported for paid elements',
            group: 'Group',
            unlockGroupRemove: 'Move element',
            copy: 'Create a copy',
            copyStyle: 'Copy style',
            delete: 'Delete',
            more: 'More',
            editText: 'Edit text',
            editChartData: 'Edit data',
            copyEffect: 'Copy effects',
            cursorTip: 'Press and hold Shift to apply formatting continuously',
        },
        baseOperate: {
            title: 'Unlock',
        },
        batchTemplate: {
            cover: 'Fill',
            full: 'Fit',
        },
        replaceImageOperate: {
            btnText: 'Replace',
        },
    },
    brushLayer: {
        customBrush: 'Customize brushes',
        Behavior: {
            line: 'Linear pen',
            curve: 'Curve pen',
            shape: 'Shape',
        },
        tips: {
            moveToCanvas: 'Move to canvas and edit',
        },
    },
    buyVipLayer: {
        vipText: 'Subscribe to remove watermark',
    },
    buyVipModal: {
        text: 'Member Center',
    },
    comToolBar: {
        copyBtn: {
            copyText: 'Copy',
        },
        deleteBtn: {
            delText: 'Delete',
        },
        flipBtn: {
            verticalRotate: 'Flip (V)',
            horizontalRotate: 'Flip (H)',
            layerRotate: 'Filp',
        },
        lockBtn: {
            lock: 'Lock',
            unLock: 'Unlock',
        },
        sortBtn: {
            index: 'Order',
            bottom: 'Bottom',
            top: 'Top',
            order: 'Order',
        },
        textBrushBtn: {
            copyStyle: 'Copy style',
        },
    },
    contextMenuLayer: {
        menuConfig: {
            alignLeft: 'Left alignment',
            alignRight: 'Right alignment',
            alignHorizontal: 'Center horizontally',
            alignVertical: 'Center vertically',
            alignTop: 'Top alignment',
            alignBottom: 'Bottom alignment',
            horizontalDistribution: 'Horizontal',
            verticalDistribution: 'Vertical',
            makeGroup: 'Group',
            brokeGroup: 'Ungroup',
            layerSort: 'Order',
            sortTop: 'Bring to front',
            sortBottom: 'Send to back',
            sortUp: 'Bring forward',
            sortDown: 'Send backward',
            overlap: 'Select overlapping layers',
            lock: 'Lock',
            alignCanvas: 'Align to canvas',
            alignElement: 'Align between elements',
            delete: 'Delete',
            addMySpace: 'Add to my space',
            upload: 'Upload',
            backgroundSet: 'Set as background',
            backgroundSplit: 'Separate background',
            copy: 'Copy',
            cut: 'Cut',
            paste: 'Paste',
            createCopy: 'Create a copy',
        },
        menu: {
            lock: 'Lock',
            unLock: 'Unlock',
            successText: 'The background has been separated',
        },
        upload: {
            addImage: 'Add image…',
        },
    },
    corpImage: {
        tip: 'Maximum value reached',
        scale: 'Zoom',
        adjustImage: 'Adapt',
        reset: 'Reset',
    },
    displaceMent: {
        left: 'Move left',
        right: 'Move right',
        top: 'Forward',
        bottom: 'Backward',
        deg: 'Angle',
        minValue: 'Minimum value reached',
        width: 'Width',
        height: 'Height',
    },
    downLoadTip: {
        tip: 'The work has been downloaded and saved here',
    },
    filterList: {
        errorText: 'Network error. Please try again or check your network status.',
        operate: {
            cancel: 'Cancel',
            applay: 'Apply',
            strength: 'Intensity',
            apply: 'Apply',
        },
        utils: {
            noFilter: 'No filter',
            filter: 'Frequently used',
        },
        filterCategory: {
            more: 'More',
        },
    },
    globalMask: {
        loading: 'Loading...',
    },
    groupLayer: {
        title: 'In-group movement',
    },
    hooks: {
        useNetWork: {
            onLine: 'The network has been reconnected',
            unOnLine: 'Network error. Please try again or check your network status.',
        },
    },
    imageEffectPanel: {
        title: 'Image effects',
        effect: 'Effects',
        constants: {
            normal: 'Regular',
            outSolidLine: 'Extended solid line',
            outDashedLine: 'Expanded dotted line',
            tornPaper: 'Tear paper',
        },
        imageBlur: {
            title1: 'Classic blur',
            title2: 'Blurry glass',
            classic: 'Classic',
            glass: 'Glass',
            strength: 'Intensity',
            cancel: 'Cancel',
            apply: 'Apply',
            cancelBlur: 'Cancel',
        },
        imageGlowItem: {
            title1: 'Outer glow',
            title2: 'Color',
            title3: 'Range',
            title4: 'Opacity',
            outGlow: 'Outer glow',
            color: 'Color',
            scope: 'Range',
            opacity: 'Opacity',
        },
        imageShadowItem: {
            title1: 'Shadows',
            title2: 'Color',
            title3: 'Blur',
            title4: 'Opacity',
            title5: 'Distance',
            shadow: 'Shadows',
            color: 'Color',
            blur: 'Blur',
            opacity: 'Opacity',
            dis: 'Distance',
            range: 'Range',
            direction: 'Direction',
            rotate: 'Rotate',
            brightness: 'Brightness',
            wave: 'Ripples',
            waveNum: 'Number',
            yOffset: 'Y-axis offset',
            xOffset: 'X-axis offset',
            length: 'Length',
        },
        imageStrokeItem: {
            title1: 'Stroke',
            title2: 'Color',
            title3: 'Range',
            title4: 'Opacity',
            title5: 'Style',
            stroke: 'Stroke',
            color: 'Color',
            scope: 'Range',
            opacity: 'Opacity',
            style: 'Style',
        },
        imageEffectMenu: {
            imageEffect: 'Image effects',
        },
        subTitle: {
            baseTitle: 'Basic',
            blurTitle: 'Texture Blur',
        },
        borderRadiusItem: {
            title: 'Round corners',
            modalTitle: 'Round corners settings',
        },
        imageShadowType: {
            baseProjection: 'Basic',
            lightProjection: 'Natural light',
            reflection: 'Reflection',
            waterSurface: 'Ripples',
        },
    },
    imageLayer: {
        useImageExpandHelper: {
            replaceImage: 'Please replace the picture first',
            errorText: 'Switch failed, please try again.',
        },
        renderDropImage: {
            dropImage: 'Drag image',
            freedImage: 'Drop image',
        },
    },
    appName: 'X-Design',
    loginNow: 'Log In',
    imageMatting: {
        confirmText: 'Apply cutout',
        remainPage: 'Remaining credits',
        consumeAfterApply: 'Credits needed',
        cutoutRemainPage: 'Remaining credits',
        remainPageConfirm:
            'Credits will be deducted after confirming. Processing additional images will deduct more credits.',
        mattingOptimize: 'Optimize cutout',
        cancel: 'Cancel',
        apply: 'Apply',
        consumeOne: 'Consumes ${0} credit',
        recharge: 'Top up',
        applyTips: 'This action will be applied to your image',
    },
    imageUpload: {
        btnText: 'Upload',
        heicErrorText:
            'The HEIC image failed to load. We recommend converting it to another image format before uploading.',
        beforeUploadError: 'You can upload up to ${0} images at a time',
        supportImageSize: 'Only supports images up to ${0}MB',
        supportImageType: 'Only supports JPG, PNG, HEIC, SVG, GIF, and WEBP image formats',
        sizeLimit: 'Only supports images up to ${0} x ${1}',
    },
    listCard: {
        rightText: 'All',
    },
    mainLayer: {
        brushSize: 'Size',
        penType: {
            tab: {
                legacy: 'Manual',
                aiLeGacy: 'AI Assisted',
            },
            config: {
                daub: 'Brush',
                rect: 'Box',
                path: 'Circle',
                add: 'Add',
                remove: 'Remove',
                clear: 'Clear',
                text: 'Text',
                watermark: 'Watermarks',
                unwantedPeople: 'Unwanted People',
                glass: 'Eyeglasses',
                quickStartDesc: 'Choose categories — we’ll detect and remove distractions for you.',
                quickStart: 'Auto Removal',
                advanced: 'Manual Removal',
                advancedDesc: 'Simply select or brush over anything you want to remove.',
                glare: 'Glare',
            },
        },
        enhance: {
            config: {
                smartLightAlpha: 'Auto fill light',
                light: 'Brightness',
                contrast: 'Contrast',
                saturation: 'Saturation',
                structure: 'Clarity',
                sharpen: 'Sharpness',
                temperature: 'Color Temperature',
                tinge: 'Tint',
                hslHue: 'Hue',
                hslSaturation: 'Saturation',
                hslLight: 'Lightness',
                highlight: 'Highlights',
                shadow: 'Shadows',
                fade: 'Fading',
                vignette: 'Vignette',
                particle: 'Grain',
                dispersion: 'Defringe',
                posterizeLight: 'Saturation',
            },
        },
        posterSize: {
            light: 'Highlights',
            shadow: 'Shadows',
        },
        intelligent: {
            protectArea: {
                pen: 'Brush',
                eraser: 'Eraser',
                messageInfo: 'Please exit first',
                title: 'Brush the kept area in the image.',
                brushSize: 'Size',
                clearProtectArea: 'Clear area lock',
                startProtectArea: 'Lock area',
            },
            selectColor: {
                messageInfo1:
                    'This feature only applies to the original photo, Inaccessible content has been hidden automatically',
                messageInfo2: 'Clear locked areas before picking colors',
                selectColor: 'Select the color of the original image',
            },
            reset: 'Reset',
            sourceColor: 'Source color',
            sourceColorDesc: 'Select a color from the image',
            colorTolerance: 'Color tolerance',
            targetColor: 'Target color',
            targetColorDesc: 'Target color',
            chooseColor: 'Select color',
            erase: 'Erase',
            eraseDesc: 'Swipe to erase or select areas',
            brush: 'Brush',
            eraser: 'Eraser',
            clear: 'Clear',
            recommendedEffect: 'For you',
            resetEffect: 'Reset',
            manualColor: 'Manual',
            hue: 'Hue',
            hueDesc: 'Hue refers to colors such as blue, red, etc.',
            saturation: 'Saturation',
            saturationDesc:
                'Saturation refers to the purity of color, the higher the saturation value, the more intense the color.',
            brightness: 'Lightness',
            brightnessDesc:
                'Brightness refers to the degree of brightness of colors, the higher the brightness, the brighter the colors.',
            messageInfo: 'Please exit first',
            messageInfo1:
                'This feature only applies to the original photo, Inaccessible content has been hidden automatically',
            messageInfo2: 'Clear locked areas before picking colors',
        },
        models: {
            config: {
                all: 'All',
                pickColor: 'Color',
            },
        },
        operate: {
            colorPickPen: 'Maximum number reached',
            messageInfo:
                'This feature only applies to the original photo, Inaccessible content has been hidden automatically',
            handleMessage: 'Processing...',
            errorMessage: 'Failed to remove. Try again.',
            startErase: 'Remove',
            autoRecognizing: 'Detecting...',
            emptyAreaTips: "Select the area you'd like to erase",
            textEmptyAreaTips: 'No text detected. Please try manually selecting the section you want to remove.',
            watermarkEmptyAreaTips:
                'No watermark detected. Please try manually selecting the section you want to remove.',
            glassesEmptyAreaTips: 'No glasses detected. Please try selecting the area manually to remove them.',
            passerbyEmptyAreaTips:
                'No passerby detected. Please try manually selecting the section you want to remove.',
            auditFailedTips: 'Failed to process. Try other photos.',
            inputAuditFailedTips: 'Failed to process. Try other photos.',
        },
        selectionTools: 'Selection settings',
        autoIdentification: 'Auto',
    },
    navigatorLayer: {
        adaptScale: 'Full screen',
        realSize: 'Actual size',
        open: 'Expand navigator',
        hidden: 'Hide',
        minCanvas: 'Canvas minimized',
        maxCanvas: 'Canvas maximized',
        shrink: 'Zoom out',
        enlarge: 'Zoom in',
        keyboardKeyMap: 'Shortcuts',
        contactMessage: 'Online consultation',
        feedBack: 'Feedback',
        referenceLine: 'Guides',
        verticalReferenceLine: 'Vertical guides',
        horizontalReferenceLine: 'Horizontal guides',
        clearReferenceLine: 'Clear guides',
        contrast: 'Compare',
        pressToView: 'Press and hold to view original photo',
        canvasSize: 'Canvas size',
        showRulerBar: 'Show rulers',
        hideRulerBar: 'Hide rulers',
        referenceLinesAndRulers: 'Guides and rulers',
        releaseToDelete: 'Let go to delete',
    },
    psdParse: {
        delLayer: 'Remove hidden layers',
        parseLayer: 'Analyzing layer data',
        waitingText: 'Resizing the text layer may take some time. Please wait.',
        replaceFont: 'Text layer ${0}: The ${1} font has been replaced.',
        computedSize: 'Calculate the width and height of the layer',
        genPreview: 'Preview Image',
        mixLayer: 'Merge',
        parseEnd: 'Analysis completed',
        readPsdData: 'Access PSD data',
        emptyPsdData: 'The PSD file is empty',
        limitCount: 'We support up to 20 artboards. Please reduce the number and upload again.',
        retryUpload1: 'Nested artboards not allowed. Please upload again.',
        retryUpload2: 'The longest side should not exceed 2448px. Upload smaller size.',
        bgLayerError: 'The background layer does not meet the standard',
        parseTextLayer: 'Analyze text layer: ${0}',
        emptyBgSize: 'The dimensions of the background layer cannot be 0.',
        minBgSize: 'The width and height of the background layer cannot be less than 10.',
        maxBgSize: 'The dimensions of the background layer must not exceed twice the size of the canvas.',
        bgLayer: 'Background Layer',
        noChildLayer: 'Layer ${groupLayer.title}: Invalid layer detected. No sub-layers found.',
        parseImageLayer: 'Analyze image layer: ${0}',
        qrCode: 'QR code',
        maxImageLayerMultiple:
            'Image layer ${0}: The dimensions of this layer are more than twice the size of the current canvas.',
        minImageLayerSizeOf0: 'Image layer ${0}: Width and height cannot be less than 0',
        minImageLayerSizeOf10: 'Image layer ${0}: The width and height cannot both be less than 10px',
        emptyUrl: 'Image layer ${0}: URL is empty; unable to analyze the image.',
        minTextLayerSize: 'Text layer ${0}: The font size cannot exceed the width of the template',
        minTextLayerSizeOf0: 'Text layer ${0}: Width and height cannot be less than 0',
        minTextLayerSizeOf10: 'Text layer ${0}: The width and height cannot both be less than 10px.',
        minTextLayerSpacingOf0: 'Text layer ${0}: The line spacing is less than 0',
        textLayerSpacingMinFont: 'Text layer ${0}: The line spacing is smaller than the font size',
        minTextLayerFontOf12: 'Text layer ${0}: The font size is less than 12',
        emptyTextLayer: 'Text layer ${0}: The text is empty; possibly a blank layer.',
        customImageName: 'Custom Image',
        parseVectorLayer: 'Analyze vector layer: ${0}',
        maxVectorMultiple:
            'Vector layer ${0}: The dimensions of this layer are more than twice the size of the current canvas.',
        minVectorSize: 'Vector layer ${0}: Width and height cannot be less than 0',
        replaceFonts: 'The font has been replaced with ${0}',
        emptyBg: 'There is no background layer, or the background layer is not in the first position.',
        layerWidthOf0: "The layer's width is 0",
        layerHeightOf0: "The layer's height is 0",
        minLayerWidthOf10: 'Is there an issue if the layer width is less than 10?',
        minLayerHeightOf10: 'Is there an issue if the layer height is less than 10?',
        emptyUrlText: 'The image URL does not exist',
        fontSpaceLimit0: 'The text spacing is less than 0',
        spaceMinFont: 'The line spacing is less than the font size',
        fontLimit12: 'The font size is less than 12px',
        emptyText: 'The text field is empty; possibly a blank layer.',
        emptyLayer: 'The layer group has no sub-layers; possibly an invalid layer group.',
        maxMaskLimitCanvas: 'Mask ${0}: It should not exceed 1.5 times the size of the current canvas.',
    },
    request: {
        errorText: 'Request error. Try again later.',
    },
    stageManager: {
        canvasLimitScope: 'Canvas size needs to be within limits',
        height: 'H',
        width: 'W',
        page: 'Pages',
        prePage: 'Previous',
        moveUpPage: 'Forward',
        nextPage: 'Next',
        moveDownPage: 'Backward',
        addPage: 'Add page',
        copyPage: 'Copy page',
        delPage: 'Delete page',
        dragHeight: 'Drag the page to adjust its height',
        maxStageLimit: 'You can add up to ${0} artboards',
    },
    svgLayer: {
        edgsConfig: {
            triangle: '3 (Triangle)',
            diamond: '4 (Diamond)',
            pentagon: '5 (Pentagon)',
        },
        shapeConfig: {
            line: 'Straight Line',
            arrow: 'Arrow',
            curve: 'Curve',
            circle: 'Round',
            square: 'Rectangle',
            polygon: 'Polygon',
            heart: 'Heart-shaped',
            star: 'Star',
        },
        dasharray: 'Brush types',
        edgs: 'Number of sides',
        fillColor: 'Fill color',
        brushSrength: 'Intensity',
        radius: 'Round corners',
        reset: 'Reset',
        strokeColor: 'Brush color',
        brushWidth: 'Size',
    },
    tableLayer: {
        mergeCell: 'Merge Cells',
        cancelMergeCell: 'Split Cells',
        column: 'Columns',
        row: 'Rows',
        behavior: {
            limitWidth: 'Minimum width limit reached',
            limitHeight: 'Minimum height limit reached',
        },
        hooks: {
            supportText:
                'Only files with ${0} rows x ${1} columns are supported. Any excess will be automatically discarded.',
            maxSupportText: 'Up to ${0} rows x ${1} columns are supported',
            upAdd: 'Add above',
            downAdd: 'Add below',
            delSelectRow: 'Remove selected rows',
            leftAdd: 'Add on left',
            rightAdd: 'Add on right',
            delSelectColumn: 'Remove selected columns',
            clear: 'Clear content',
            parseFailed: 'Failed to analyze the table',
        },
        panel: {
            count: 'Rows & Columns',
            color: 'Cell Color',
            borderStyle: 'Border Style',
            lineStyle: 'Line Style',
            autoWrap: 'Wrap Text',
            selectStyle: 'Select table style',
        },
        delete: 'Delete',
        columnShort: 'C',
        rowShort: 'R',
    },
    textAction: {
        fontSpacing: 'Text spacing',
        rowSpacing: 'Line spacing',
        opacity: 'Opacity',
        spacing: 'Spacing',
    },
    textAlign: {
        alignLeft: 'Left alignment',
        alignRight: 'Right Align',
        alignTop: 'Top Align',
        alignBottom: 'Bottom Align',
        alignCenter: 'Center',
        alignBetween: 'Align at Both Ends',
        textPosition: 'Text Direction',
        textSpacing: 'Text spacing',
        rowSpacing: 'Line spacing',
        listFormat: 'List Format',
    },
    textAlignMent: {
        align: 'Align',
        alignLeft: 'Left alignment',
        alignRight: 'Right Align',
        alignTop: 'Top Align',
        alignBottom: 'Bottom Align',
        alignCenter: 'Center',
        alignBetween: 'Align at Both Ends',
        alginVertical: 'Center Vertically',
    },
    textAttr: {
        style: 'Style',
        strong: 'Bold',
        italic: 'Italic',
        underLine: 'Underline',
        lineThrough: 'Strikethrough',
        textVertical: 'Vertical Text',
        listFormat: 'List Format',
    },
    utils: {
        uploadNetworkErr: 'Upload failed due to network issues',
        networkErr: 'Network error. Unable to connect to the server.',
    },
    userInfo: {
        vipOutDate: 'VIP expires on:',
        notVipInfo: 'You are not yet a member',
        vipOutDateInfo: 'Your membership has expired',
        loginAndCheckState: 'Log in to view member details',
        buyVipAndEnjoyVip: 'Renew to enjoy exclusive elements and features',
    },
    thresholdListPanel: {
        vipContentInfo: 'This creation includes ${0} VIP elements',
        needPayContentInfo: '${0} VIP elements included',
    },
    textStyleSelector: {
        clearStyle: 'Clear styles',
        specialEffect: 'Effects',
    },
    textStyleAdd: {
        color: 'Color',
        range: 'Range',
        blur: 'Blur',
        distance: 'Distance',
        opacity: 'Opacity',
        fillOrGradient: 'Fill/Gradient',
        stroke: 'Stroke',
        shadow: 'Shadows',
        glow: 'Outer glow',
        background: 'Background',
    },
    textListStyle: {
        color: 'Color',
        size: 'Size',
    },
    textLayer: {
        defaultText: 'Tap twice to edit',
        unorderList: 'Unordered List',
        orderList: 'Ordered List',
        strength: 'Intensity',
        size: 'Size',
        startAngel: 'Start Angle',
        eccentricity: 'Eccentricity',
        reversePath: 'Reverse Path',
        widthHeightRatio: 'Ratio',
        startPosition: 'Start Position',
        widthLength: 'Length',
        sideLength: 'Number of sides',
        roundRadius: 'Round corners',
        relativeHeight: 'Relative height',
    },
    textFontSizeAndTextColor: {
        size: 'Size',
    },
    textFontSize: {
        limit: 'Enter a integer between ${0} and ${1}',
    },
    textFontFamily: {
        empty: 'No content',
        changeSearchWord: 'Try using a different search term',
        fontFamily: 'Font',
        searchFont: 'Search font',
        buyVipEnjoyFontFamily: 'Free for commercial use',
        currentFontFamily: 'Fonts used in this template',
    },
    layers: {
        text: 'Text',
        image: 'Images',
        vector: 'Graphics',
        background: 'Background',
        group: 'Group',
        qrCode: 'QR code',
        table: 'Sheet',
        brush: 'Brush',
        watermark: 'Watermarks',
        markup: 'Marker',
        chart: 'Chart',
    },
    keyboardKeyMap: {
        title: 'Shortcuts',
        function: 'Features',
        windows: 'Windows',
        mac: 'Mac',
        undo: 'Undo',
        redo: 'Redo',
        delete: 'Delete',
        cut: 'Cut',
        copy: 'Copy',
        paste: 'Paste',
        selectAll: 'Select all',
        multipleSelect: 'Multi-select',
        multipleSelectDescWin: 'Press Ctrl/Alt and click the layer',
        multipleSelectDescMac: 'Press ⌘/⌥ and click the layer',
        makeGroup: 'Group',
        brokeGroup: 'Ungroup',
        lock: 'Unlock layer/Lock layer',
        saveRecord: 'Save record',
        save: 'Save/Download picture',
        move: 'Move 1px',
        ArrowKey: 'Arrow keys',
        scale: 'Zoom in/Zoom out',
        sortTop: 'Bring to front',
        sortBottom: 'Send to back',
        sortUp: 'Bring forward',
        sortDown: 'Send backward',
        exitFullScreen: 'Exit',
        esc: 'Esc',
        toggleReferenceLine: 'Show/hide guides',
        fixedPaste: 'Paste in Place',
        createCopy: 'Create a copy',
        createText: 'Add text',
        createRect: 'Add rectangle',
        createCircle: 'Add circle',
        createLine: 'Add straight line',
        toggleRulerBar: 'Show/hide rulers',
    },
    infiniteScroll: {
        loading: 'Loading...',
    },
    markupLayer: {
        tips: {
            firstClick: 'Click to start marking',
            secondClick: 'Click to stop marking',
            thirdClick: 'Drag to extend the marking',
        },
    },
    textMarkSelector: {
        mark: 'Highlight',
        color: 'Color',
        size: 'Size',
        disabledByWritingMode: 'Unable to mark text in a vertical layout',
        disabledByTransform: 'Unable to mark warped text',
        disabledByTextMark: 'Unable to mark text in a vertical layout',
    },
    rulerBarPlugin: {
        switchStageUnit: 'Unit',
    },
    collapse: {
        messageError: {
            requestFailed: 'Failed to request element',
            networkFailed: 'Network error. Unable to connect to the server.',
            noNetwork: 'Network connection lost. Please reconnect and try again.',
            heicError:
                'The HEIC image failed to load. We recommend converting it to another image format before uploading.',
            filetypeLimit: 'Only supports JPG, PNG, HEIC, SVG, GIF, and WEBP image formats',
            parsingFailed: 'Failed to load. We recommend converting it to another image format before uploading.',
            addFailed: 'Failed to add, please try again.',
        },
        tips: {
            deleteTitle: 'Deletion tips',
            deleteDesc: 'Once deleted, it cannot be retrieved. Please proceed with caution.',
            okText: 'Delete',
            cancelText: 'Cancel',
            deleteSuccess: 'Successfully deleted!',
            addSuccess: 'Added successfully',
            addLoading: 'Adding...',
            selected: '<></> selected',
            recordDeleteDesc: 'Once the record is deleted, it cannot be retrieved. Please proceed with caution.',
            uploadDesc: 'Click to upload files or drag and drop',
            uploadLimit: 'Only supports images up to 20MB',
            uploadMaxLimit: 'Upload up to 10 images',
            noContent: 'No content',
            corner: 'Corner marker image',
            uploadSuccess: 'Uploaded',
            noMore: 'No more content',
            uploading: 'Uploading...',
            sizeLimit: 'Only supports images up to ${0} x ${1}',
        },
        backgroundCollapse: {
            title: 'Background color',
            detailTitle: 'Background Column Details',
            recentUsed: 'Frequently used',
            all: 'All',
            messageError: {
                applyFailed: 'Background application failed',
            },
            kindTips: 'Friendly Reminder',
            applyTips: 'The photo has been edited. Apply this effect?',
            apply: 'Apply',
            cancel: 'Cancel',
            messageInfo:
                'This feature only applies to the original photo, Inaccessible content has been hidden automatically',
        },
        brushCollapse: {
            linePen: 'Linear pen',
            curvePen: 'Curve pen',
            shape: 'Shape',
            choose: 'Select drawing tool',
            tips: {
                moveToCanvas: 'Move to canvas and edit',
                firstClick: 'Click to start marking',
                secondClick: 'Click to stop marking',
                thirdClick: 'Drag to extend the marking',
            },
            all: 'All',
            custom: 'Custom',
            markupPen: 'Marker',
            defineCurvePen: 'Customize curve pen',
            defineLinePen: 'Customize linear pen',
            penStyle: 'Brush style',
            stroke: 'Stroke',
            free: 'Free',
        },
        materialCollapse: {
            newestTitle: 'New',
            detailTitle: 'Element Column Details',
            commonUsed: 'Frequently used',
            recentUsed: 'Recently Used',
            recentSearch: 'Search history',
            clearRecord: 'Clear history',
            hotSearch: 'Top searches',
            all: 'All',
            more: 'More >',
            colors: 'Color',
            reload: 'Reload',
            feedback: 'Feedback',
            searchPlaceholder: 'Search elements',
            similarTitle: 'Similar Elements',
            viewMore: 'More',
            similarRecommend: 'You may also like',
            loading: 'Loading...',
            similarTag: 'Similar Tags',
            tips: {
                noContent: 'No content',
                noContentDesc: 'Try using a different search term ${0} or provide us with your feedback.',
                noNetwork: 'There is a problem with the network.${0} Try reloading.',
            },
        },
        mineCollapse: {
            mySpace: 'Assets',
            myRecord: 'Recent Designs',
            reUpload: 'Replace',
            addMaterial: 'Add Element',
            noRecord: 'No design records found. Start now!',
            pptPage: '${0} page(s) PPT',
            multiplePage: '${0} pages',
            all: 'All',
            delete: 'Delete',
            exit: 'Exit',
            image: 'Images',
            text: 'Text',
            group: 'Group',
            folder: 'Folder',
            records: 'Recent Designs',
            elements: 'Elements',
            myShare: 'Shared content',
            add: 'Add',
            noneFolder: 'No folders found',
            collapse: 'Collapse',
            expand: 'Expand',
            viewAll: 'View all',
            type: 'Type',
            noFilesYet: 'No files have been added',
            upload: 'Upload',
            poster: 'Poster Editor',
            imageEditor: 'Edit image',
            upGradeTipsTitle: 'New updates available!',
            upGradeTipsContent:
                'Both poster templates and photo editing records are included. Smooth switch from editing photos to designing posters.',
            upGradeTipsOk: 'Got it',
            steps: {
                content: 'Here you’ll find both filters and colors',
                okText: 'Got it',
            },
            productShoot: 'AI Commercial Photography',
            aiLogo: 'AI Logo',
            aiShoeDesign: 'AI Product Design',
            aigcRecords: 'Creations',
        },
        templateCollapse: {
            recommend: 'For you',
            recentView: 'Recently viewed',
            homePage: 'Home',
            backToList: 'Back to list',
            applyAllPage: 'Apply to all pages',
            all: 'All',
            filter: 'Filter',
            feedback: 'Feedback',
            search: {
                placeholder: 'Search templates',
                hotSearch: 'Top searches',
                recentSearch: 'Search history',
                searchKeyword: 'Search "${0}"',
                clear: 'Clear',
            },
            tips: {
                noContent: 'No content',
                noContentDesc: 'Try using a different search term ${0} or provide us with your feedback.',
                applyWouldReplace: 'After using the template, the current content will be replaced.',
                replaceCurrentTemplate: 'Replace all pages',
                replaceCurrentPage: 'Replace current page',
                replaceAllPage: 'Replace all pages',
                replaceWouldApplyNewPage: 'How would you like to open this template?',
                replaceWouldApplyAllPage: 'After replacing the template, the content will be applied to all pages.',
                addToNewPage: 'Add a new page',
                replace: 'Replace',
                cancel: 'Cancel',
                openNewTab: 'In a new tab',
            },
            aippt: {
                replaceTemplateTitle: 'Switch',
                applyTemplateBtn: 'Switch',
                selectTemplateTip: 'Please select a template first',
            },
        },
        teamCollapse: {
            template: 'Templates',
            material: 'Elements',
            group: 'Label group',
            ungrouped: 'Ungrouped',
            backToList: 'Back to list',
            applyAllPage: 'Apply to all pages',
            addMaterial: 'Add Element',
            reUpload: 'Replace',
            importTemplate: 'Import template',
            all: 'All',
            upload: 'Upload',
            exit: 'Exit',
            delete: 'Delete',
            tips: {
                uploading: 'Uploading...',
                noText: 'No text layer',
                noTag: 'There are no tags in the group yet',
                noTemplate: 'There is no template yet. Upload your template.',
                parsing: 'Parsing...',
                parseFailed: 'Failed to analyze',
                parseSuccess: 'Parsed successfully',
                reUpload: 'Replace',
                continueUpload: 'Upload',
                uploadSuccess: 'Uploaded',
                chooseFile: 'Select a document',
                dropFileOr: 'Drag files here to upload, or',
                psdImportSpecification: 'PSD file import specifications',
                applyWouldReplace: 'After using the template, the current content will be replaced.',
                replaceCurrentTemplate: 'Replace current template',
                replaceCurrentPage: 'Replace current page',
                replaceAllPage: 'Replace all pages',
                replaceWouldApplyNewPage: 'After replacing the template, the content will be applied to the new page.',
                replaceWouldApplyAllPage: 'After replacing the template, the content will be applied to all pages.',
                addToNewPage: 'Add as new page',
                replace: 'Replace',
                cancel: 'Cancel',
            },
            messageError: {
                needUploadPsd: 'Please upload PSD file!',
                psdSizeLimit: 'Please verify if the PSD file exceeds 600MB.',
                uploadFailed: 'Failed to upload',
                uploadFailedReTry: 'Failed to upload. Please try again.',
            },
        },
        navigationCollapse: {
            createPage: 'Create',
            addPage: 'Add page',
            copyPage: 'Copy page',
            deletePage: 'Delete page',
            submit: 'Submit',
            ppt: {
                currentSubject: 'Current PPT theme',
                prompt: 'Prompt (command)',
                placeHolder:
                    'Review the generated content and provide a related description for AI to enhance it, e.g., "Include additional details about ${0} in the PPT."',
                singlePptGenerate: 'Generate single-page PPT',
                tips: {
                    generateSuccess: 'Generated successfully',
                    singlePptGenerating: 'Generating single-page PPT...',
                    pptReGenerating: 'Regenerate page ${0}',
                    reGenerate: 'Regenerate',
                },
            },
            replaceComponentTitle: 'Choose a style',
            changeAnotherComponent: 'Switch',
            componentReplacing: 'Applying style...',
            noComponentTip: 'No qualified style matched',
            page: 'Pages',
        },
        textCollapse: {
            defaultText: 'Tap twice to edit',
            commonUsed: 'Frequently used',
            recentUsed: 'Recently Used',
            clickToAddText: 'Click to add text',
            title: 'Title',
            subTitle: 'Subtitle',
            contentText: 'Text',
            more: 'More >',
            all: 'All',
            messageError: {
                needNewest: 'Please use the latest text elements',
                fetchFailed: 'Failed to obtain element',
            },
            search: {
                placeholder: 'Enter text',
            },
        },
        moreCollapse: {
            componentTool: {
                title: 'Components',
                table: {
                    title: 'Sheet',
                    desc: 'Provides rich styles and supports importing Excel files.',
                    importExcel: 'Import Excel files',
                    importExcelLimit: 'Import Excel files with ${0} rows and ${1} columns',
                    needSelected: 'Select a style',
                    messageError: {
                        filetypeLimit: 'Only supports .xlsx files',
                    },
                },
                qrCode: {
                    title: 'QR code',
                    desc: 'Generate QR codes for websites or official accounts, all while offering a wide variety of stylish designs.',
                    website: 'Website',
                    official: 'Official Account',
                    needSelected: 'Select a style',
                    createQrCode: 'Create QR code',
                    uploadQrCode: 'Upload',
                    messageError: {
                        officialInputError: 'Please enter correct official account',
                        recognitionFailed: 'Recognition failed. Please upload a correct and clear QR code image.',
                    },
                    intlDesc: 'Generate QR codes from website addresses with customizable styles.',
                    intlTabTip: 'Enter website address',
                },
            },
            imageModal: {
                title: 'Before using ${0}, please select an image first!',
                desc: 'Select an image from a poster template',
                uploadImage: 'Upload',
                messageError: {
                    uploadFailed: 'Failed to upload photo',
                },
            },
            imageTool: {
                title: 'Picture tools',
                generate: 'Generate',
                generating: 'Generating...',
                result: 'Results:',
                reGenerate: 'Regenerate',
                imGenerate: 'Generate',
                image: 'Images',
                apply: 'Apply',
                exit: 'Exit',
                messageError: {
                    failed: 'Generation failed',
                    aiFailed: 'AI ${0} failed',
                    meidouReturned: 'The credits have been returned',
                },
                aiExpend: {
                    title: 'AI Image Extender',
                    desc: 'Enhance your images by expanding them from their original size, with support for a variety of size options.',
                    originalRadio: 'Original',
                    sizeTitle: 'Size',
                    radioTitle: 'Ratio',
                    expend: 'Image Extender',
                    toast: "You've reached the canvas limit and can't expand the image further.",
                },
                aiModify: {
                    title: 'Modify',
                    desc: 'Enter a description, and AI will generate image content within the specified area based on the description.',
                    internalTest: 'Beta',
                    promptDefault: 'A groundhog',
                    paintTitle: 'Brush to select:',
                    paintDescTitle: 'Enter your description:',
                    tips: {
                        inputLimit: 'You can enter up to 1,000 characters',
                        inputPlaceholder: "Please describe the content you're looking for",
                        guide: 'Please select the area and fill in your description',
                    },
                    modify: 'Try again',
                    reset: 'Reset',
                },
                imageTranslation: {
                    title: 'Image Translation',
                    desc: 'Easily translate and edit image text in multiple languages to streamline cross-border marketing.',
                    selectOriginalLanguage: 'Select source language',
                    selectTranslation: 'Select target language',
                    translate: 'Translate',
                    translateAgain: 'Retry',
                    original: 'Source',
                    translation: 'Target',
                    translationResult: 'Result',
                    noResult: 'No content found in the source language. Please make another selection.',
                    fail: 'Image translation failed. Please try again.',
                    ok: 'Got it',
                    apply: 'Confirm',
                    cancel: 'Cancel',
                    confirmText:
                        "If you exit now, the translation will be interrupted, and you won't be able to continue from where you left off. Do you want to exit anyway?",
                    sameSelect:
                        'You’ve selected the same language for both the source and target. Please choose different languages.',
                },
            },
            textTool: {
                title: 'Text tool',
                generate: 'Generate',
                generating: 'Generating...',
                result: 'Results:',
                reGenerate: 'Regenerate',
                imGenerate: 'Generate',
                aiText: {
                    title: 'AI Calligraphy',
                    desc: 'Creative text effects, perfect for poster headlines.',
                    generating: 'Generating AI calligraphy...',
                    selectedTitle: 'Featured effects',
                    aiTextDesc: 'Generate 1 to ${0} characters at a time for best results',
                    content: 'Content',
                    font: 'Font',
                    style: 'Style',
                    textPreview: 'Text preview:',
                    tips: {
                        inputPlaceholder: 'Please enter content',
                        disclaimer: 'Disclaimer',
                        disclaimerContent:
                            "Before using this service, you must understand that the content produced by AI depends on the deep learning of big data by artificial intelligence. There may be flaws, irrationalities, or displeasing elements in some of the information. Hence, X-Design does not guarantee the accuracy, completeness, and functionality of the content generated by the algorithm, nor does it assume any legal responsibility, including infringement of third-party rights. Moreover, as the AI design service generates related content based on the text information you input, you need to make rational choices about the input information and the generated content. You must ensure that you use this service and its AI-generated works in accordance with the law, without infringing on any third party's copyright, trademark, or other legal rights. You may not use the generated works for any illegal purposes. If any third party's rights are damaged due to your improper use, you will bear the corresponding legal responsibility according to the law.",
                    },
                    messageError: {
                        needContent: 'Please enter content',
                        needSelected: 'Please select an effect',
                        failed: 'Generation failed, please try again.',
                        inputLimit: 'Enter up to ${0} characters',
                    },
                },
            },
            migrateHint: 'Click Add to create tables and QR codes',
            batchTool: {
                title: 'Batch process',
                aiSizeExtend: {
                    title: 'Resize',
                    desc: "Adjust an image's width and height, keeping or changing its aspect ratio.",
                    currentCanvasSize: 'Current size',
                    unit: 'Unit',
                    selectDesc: 'Select a size',
                    free: 'Free',
                    width: 'Width',
                    height: 'High',
                    generateBtnText: 'Generate ${0} resize page(s)',
                },
                batchTemplate: {
                    title: 'Templated Multi-Design',
                    desc: 'Simply input text or images to generate a multitude of posters with the same template but different content.',
                    operateTip: 'Select an element - Click Match Tag - Choose a tag',
                    changeDataBtnText: 'Edit',
                    generateBtnText: 'Generate ${0} page(s)',
                    exitBtnText: 'Exit this page',
                    clearTableBtnText: 'Clear',
                    nextBtnText: 'Next',
                    cancelBtnText: 'Cancel',
                    conformBtnText: 'Confirm',
                    noInputLabelTip: 'Select a tag and enter a name',
                    noMatchLabelTipText:
                        'Some tags have not been matched yet. Continuing the generation process will result in the loss of this information. Do you wish to proceed?',
                    clearAllDataTipText:
                        'Upon exiting, the information filled in will be cleared. Are you sure you want to exit?',
                    max80PageTipText: 'The number of pages exceeds the limit (80). Adjust the number and try again.',
                    onlyUploadPngJpgTipText: 'Only images in JPG or PNG format can be uploaded',
                    maxFileSizeTipText: 'Only supports images up to 20MB',
                    maxImageSizeTipText: 'The dimensions of the image must not exceed 8000 pixels',
                    inputLabelTypePlaceholder: 'Enter tag name',
                    labelTypeImageName: 'Images',
                    labelTypeTextName: 'Text',
                    labelTypeNoSelectName: 'Type',
                    tableInputLine1:
                        '1. Please select the type of tag from the dropdown menu: text or image, and then enter the tag name.',
                    tableInputLine2: '2. After selecting a tag, fill in the corresponding content or upload an image.',
                    clearTableTipText: 'Are you sure you want to clear the current table content?',
                    changeLabelTypeClearDataTipText:
                        "After switching types, the information you've filled in will be cleared. Are you sure you want to proceed?",
                    noMatchLayerText: 'Not matched yet',
                    isGeneratingText: 'Generating...',
                    tipTitle1: 'Manul input:',
                    tipTitle2: 'Upload file:',
                    tip1: '1. Please select the type of tag from the dropdown menu: text or image, and then enter the tag name.',
                    tip2: "2. Once you've confirmed the tag, add text content or upload an image.",
                    tip3: '1. Both .xlsx and .xls file formats are supported.',
                    tip4: '2. The first row of content will be identified as tag information, while any content below it will be recognized as page information.',
                    tip5: '3. Images are not supported.',
                    uploadBtn: 'Upload',
                    uploadTip: 'The information already filled in will be overwritten. Do you want to continue?',
                    uploadFailTip: 'Please ensure that you upload files in the correct format',
                },
            },
        },
        shortcutCollapse: {
            picture: {
                title: 'Images',
                localUpload: 'Local',
                myPicture: 'My Images',
                more: 'More >',
            },
            text: {
                menuTitle: 'Text',
                title: 'Title',
                subTitle: 'Subtitle',
                text: 'Text',
                deformedLetters: 'Warp text',
                specialEffectText: 'Special effects',
                more: 'More >',
            },
            Brush: {
                title: 'Lines',
                more: 'More >',
            },
        },
        adjustCollapse: {
            cropTitle: 'Crop/Rotate/Size',
            sizeAdjustment: 'Size',
            proportionalCrop: 'Crop',
            shapeMask: 'Mask',
            okText: 'Confirm',
            cancelText: 'Cancel',
            intelligentColor: 'Change Color',
            sourceColor: 'Source color',
            sourceColorDesc: 'Select a color from the image',
            colorTolerance: 'Color tolerance',
            targetColor: 'Target color',
            targetColorDesc: 'Target color',
            eraser: 'Erase',
            eraserDesc: 'Swipe to erase or select areas',
            clear: 'Clear',
            recommendedEffect: 'For you',
            resetEffect: 'Reset',
            manualColor: 'Manual',
            hue: 'Hue',
            saturation: 'Saturation',
            brightness: 'Lightness',
            clearEffect: 'Clear effects',
            noEffectOnEmptyCanvas: "The current feature doesn't work with the blank canvas",
            addCustomSize: 'Save as Custom Size',
            apply: 'Apply',
            custom: 'Custom',
            lockedScale: 'Ratio locked',
            unLockedScale: 'Ratio unlocked',
            leftRotate: 'Rotate 90° left',
            rightRotate: 'Rotate 90° right',
            horizontalFlip: 'Flip (H)',
            verticalFlip: 'Flip (V)',
            reset: 'Reset',
            freeCutting: 'Free',
            px: ' px',
            cm: 'cm',
            cropList: {
                square: '1:1',
                verticalCamera: '2:3',
                horizontalCamera: '3:2',
                standardVerticalScreen: '3:4',
                standardHorizontalScreen: '4:3',
                verticalVideo: '9:16',
                horizontalVideo: '16:9',
                verticalFullScreen: '9:18',
                horizontalFullScreen: '18:9',
                widescreenPhotoAlbum: '5:3',
            },
            losslessResizing: 'Image Upscaler',
            losslessResizingDesc: 'Enhance image quality for optimal clarity',
        },
        filterCollapse: {
            confirmTitle: 'Friendly Reminder',
            confirmContent: 'The photo has been edited. Apply this effect?',
        },
        watermarkCollapse: {
            addSuccessText: 'Added successfully',
            onLineError: 'Network connection lost. Please reconnect and try again.',
            all: 'All',
            confirmContent:
                'You can only edit one watermark. If you proceed, your current watermark will be replaced. Would you like to proceed?',
            confirmNoMind: "Don't show again",
            confirmTitle: 'Tips',
            confirmOk: 'Confirm',
            confirmCancel: 'Cancel',
            materialDetail: 'Element Column Details',
            recommendMaterial: 'For you',
            recentlyMaterial: 'Recently Used',
            uploadWatermark: 'Upload',
            limitImageSize: 'Only supports images up to 20MB',
        },
        brandLibCollapse: {
            brandTabTitle: 'Brand Kit',
            templateTabTitle: 'Template Library',
            textStyleTitle: 'Text style',
            logoTitle: 'Logo',
            more: 'All',
            emptyText: 'No content',
        },
        mogCollapse: {
            preset: 'Color Presets',
            reset: 'Reset',
            none: 'None',
        },
    },
    panel: {
        markupPanel: {
            thickness: 'Thickness',
            brush: 'Lines',
            label: 'Text',
            type: 'Type',
            num: 'Value',
            custom: 'Text',
            unit: 'Unit',
            unitPlaceholder: 'Select unit',
            unitTip:
                'When multiple units are selected, the entered values will be converted and displayed using the smallest unit. For example: 100mm/10cm/3.94inch.',
            text: 'Text',
            textPlaceholder: 'Enter text',
            position: 'Position',
            up: 'Above the line',
            center: 'In the middle of the line',
            down: 'Below the line',
            rotate: 'Angle',
            fontFamily: 'Fonts',
            fontSize: 'Size',
            style: 'Style',
            background: 'Background color',
            stroke: 'Stroke',
            color: 'Color',
            endpoint: 'Endpoint',
            line: 'Show extension line',
            opacity: 'Opacity',
            segment: 'Guide',
            lineStyle: 'Line style',
            angle: 'Angle',
            angleArea: 'Degree',
        },
        backgroundPanel: {
            canvas: 'Canvas',
            canvasSize: 'Canvas size',
            adjustSize: 'Size',
            horizontalFlip: 'Flip (H)',
            verticalFlip: 'Flip (V)',
            canvasBackground: 'Background',
            restoreBackground: 'Original',
            width: 'Width',
            height: 'High',
            replace: 'Replace',
            crop: 'Crop',
            color: 'Color',
            image: 'Images',
            uploadImage: 'Upload',
            cropLimit: 'The current setting is a tiled background, which does not support the cropping feature.',
            splitBackground: 'Separate background',
            opacity: 'Opacity',
            clickOrDropToUpload: 'Click to upload image${0}or drag and drop files into the box to upload.',
            customSize: 'Custom',
            originalSize: 'Original size',
            saveSize: 'Save size',
            presetSize: 'Presets',
            unit: 'Unit:',
            lockRatio: 'Lock aspect ratio',
            customRatio: 'Customize ratio',
            smartLayout: 'Smart layout',
            tips: {
                splitSuccess: 'The background has been separated',
                deleteConfirm: 'Are you sure you want to delete this size?',
                okText: 'Confirm',
                cancelText: 'Cancel',
                deleteSuccess: 'Successfully deleted!',
                saveSizeSuccess: 'Custom size saved successfully',
                adjustSizeWouldChangeLayout: 'After modification, the current template layout will change.',
                addToMySize: 'Add to my sizes',
                add: 'Add',
                inputSizeName: 'Enter a name',
            },
            messageError: {
                uploadNumLimit: 'You can only upload 1 image',
                canvasSizeLimit: 'Canvas size needs to be within limits',
                saveSizeFailed: 'Failed to save custom size',
                autoAdjustedToLimit: 'The dimensions have been reset to match the preset',
            },
            background: 'Background',
            imageSize: 'Size',
            backgroundSize: 'Size',
            customSizeTitle: 'My Sizes',
            addSize: 'Add',
            recommendSizeTitle: 'For you',
            currentCanvasSize: 'Current size',
            aiSizeExtend: 'Resize',
            free: 'Free',
            smartLayoutTip: 'Maintain element layout within the canvas unchanged while resizing',
            recommendColor: 'Color suggestions',
            currentBgColor: 'Current color',
            selectFromBackground: 'Select from library',
            dynamicPanel: {
                title: 'Dynamic background',
                hiddenLabel: 'Display',
                open: 'On',
                close: 'Off',
            },
            reEdit: 'Retry',
            edit: 'Edit',
            before: 'Before',
            after: 'After',
        },
        brushPanel: {
            brush: 'Lines',
            brushPen: 'Brush',
            shape: 'Shape',
            style: 'Style',
            stroke: 'Stroke',
            color: 'Color',
            endpoint: 'Endpoint',
            opacity: 'Opacity',
            radius: 'Round corners',
            thickness: 'Thickness',
        },
        groupPanel: {
            multiSelect: 'Multi-select',
            group: 'Group',
            makeGroup: 'Group',
            breakGroup: 'Ungroup',
            mergeLayer: 'Merge layers',
            tips: {
                breakGroupVipLimit: 'Ungroup not supported for paid elements',
                mergeConfirm:
                    'After merging, the selected layers will become one picture. Do you want to confirm the merging?',
                okText: 'Merge',
                cancelText: 'Cancel',
            },
        },
        imagePanel: {
            image: 'Images',
            aiImage: 'AI pictures',
            imageSetting: 'Settings',
            imageAdjust: 'Color',
            baseImageAdjust: 'Basic Correction',
            advancedImageAdjust: 'Advanced',
            adjustLight: 'Light',
            adjustColor: 'Color',
            adjustParticulars: 'Details',
            adjustPosterize: 'Split Toning',
            adjustHsl: 'HSL',
            effect: 'Effects',
            imageEliminatePen: 'Eraser',
            cancel: 'Cancel',
            complete: 'Done',
            undo: 'Undo',
            redo: 'Redo',
            reset: 'Reset',
            delete: 'Delete',
            exit: 'Exit',
            imageFilter: 'Filters',
            imageMask: 'Mask',
            aiGenerateImageTitle: 'AI picture content description',
            aiGenerateImageDesc:
                'You can modify the visual description, style, and color effects of the current element ${0} according to your needs.',
            inputPlaceholder: 'Please enter',
            generatingImage:
                'We are diligently working to bring the vision in your mind to life. Please bear with us for a moment.',
            reGenerate: 'Regenerate',
            cutoutMemberLimit: 'Insufficient number of credits. Become a member to get more.',
            cutoutRechargeLimit: 'Insufficient number of credits. Top up for more.',
            monthMemberPresent: 'Receive 50 uses/month with a monthly membership',
            seasonMemberPresent: 'Subscribe to X-Design Pro for credits.',
            yearMemberPresent: 'Receive 1,200 uses/year with a yearly membership',
            activateMember: 'Subscribe',
            discountedPrice: 'Best price $0.12/credit',
            permanentlyValid: 'The purchase is permanently valid',
            rechargeNow: 'Top up',
            replaceImage: 'Replace',
            imageCrop: 'Crop',
            imageCutout: 'Cutout',
            opacity: 'Opacity',
            pasterDesc: 'Take a screenshot and press ${0} to paste image here',
            import: 'Import',
            mySpace: 'Assets',
            teamMaterial: 'Team Elements',
            selectedPhoto: 'Featured images',
            importClipboard: 'Local',
            addImage: 'Add',
            unnamed: 'Unnamed',
            format: 'Format:',
            size: 'Size:',
            tips: {
                uploadSuccess: 'Uploaded',
                uploadLimit: 'Only supports images up to 20MB',
                deleteTitle: 'Deletion tips',
                deleteDesc: 'Once deleted, it cannot be retrieved. Please proceed with caution.',
                okText: 'Delete',
                cancelText: 'Cancel',
                deleteSuccess: 'Successfully deleted!',
                selected: '<></> selected',
                noMaterial: 'No content yet. Click to add elements to upload.',
                matting: 'Processing...',
                bathAdd: 'Batch add',
            },
            messageError: {
                generateFailed: 'Failed to generate image',
                networkError: 'Network error. Unable to connect to the server.',
                importFailed: 'Import failed',
                filetypeLimit: 'Only JPG,PNG, HEIC, and SVG images are supported',
                uploadFailed: 'Failed to upload',
            },
            share: {
                uploadImage: 'Upload',
                uploadTip: 'Upload, drop or paste images here.',
                imageTip: 'Upload JPG, JPEG, or PNG files up to 20 MB, with a maximum of ${0} images.',
                bathAdd: 'Batch add',
                imageTipText: 'JPG, JPEG and PNG images within 20 MB are supported',
                uploadCountTip: 'You can add up to ${0} images',
            },
            removeBgTip: 'Click to remove background',
        },
        qrCodePanel: {
            qrCode: 'QR code',
            style: 'Style',
            color: 'Color',
            opacity: 'Opacity',
            backgroundColor: 'Background color',
            qrCodeColor: 'QR code color',
            website: 'Website',
            official: 'Official Account',
            websitePlaceholder: 'Enter URL here',
            officialPlaceholder: 'Enter official account here',
            uploadIdentify: 'Upload',
            updateQrCode: 'Update QR code',
            selectStyle: 'Please select a style',
            messageError: {
                websiteInputError: 'Please enter the correct URL',
                officialInputError: 'Please enter correct official account',
                recognitionFailed: 'Recognition failed. Please upload a correct and clear QR code image.',
            },
        },
        tablePanel: {
            table: 'Sheet',
            opacity: 'Opacity',
            textStyle: 'Text style',
        },
        textPanel: {
            text: 'Text',
            style: 'Style',
            normal: 'Regular',
            textEffect: 'Text Effects',
            textEffectBase: 'Basic',
            textEffectArt: 'Art',
            textTransform: 'Warp Text',
            advanceSetting: 'Advanced',
            textStyle: 'Text style',
            transform: 'Warp',
            messageError: {
                generateFailed: 'Failed to generate text',
            },
            textMark: 'Highlight',
        },
        vectorPanel: {
            vectorShape: 'Graphics',
            style: 'Style',
            stroke: 'Stroke',
            color: 'Color',
            opacity: 'Opacity',
            radius: 'Round corners',
            textInfo: {
                vPadding: 'Top/Bottom',
                hPadding: 'Left/Right',
            },
            thickness: 'Thickness',
            blur: 'Blur',
            vectorEffect: 'Graphics',
            effect: {
                shadow: 'Shadows',
                reflection: 'Reflection',
                stroke: 'Stroke',
                distance: 'Distance',
                size: 'Size',
            },
            modalTitle: 'Round',
        },
        watermarkPanel: {
            openTile: 'Tiling ON',
            closeTile: 'Tiling OFF',
            watermarkText: 'Text',
            placeholderText: 'Enter text',
            watermarkSize: 'Size',
            watermarkSpace: 'Spacing',
            watermarkCross: 'Overlap',
            watermarkRotate: 'Rotate',
            requireLogin: 'Log in before uploading',
            limitImageSize: 'Only supports images up to 20MB',
            replace: 'Replace',
            watermark: 'Overlay Watermark',
            settingStyle: 'Styles',
            onlySupport: 'Tiling effect is available for watermarks only',
            opacity: 'Opacity',
            fontColor: 'Font color',
            tileDisplay: 'Tiling',
        },
        mediaPanel: {
            media: 'Animations',
            opacity: 'Opacity',
            posterPlaceholder: 'Enter video cover url here',
            videoUrlPlaceholder: 'Enter video url here',
            updatePoster: 'Update cover',
            updateVideoUrl: 'Update video url',
            posterInputError: 'Please enter the correct video cover url',
            videoUrlInputError: 'Please enter the correct video url',
        },
    },
    productRetouching: {
        apply: 'Edit',
        applying: 'Processing...',
        productRetouching: 'Retouch',
        common: 'General',
        hardware: 'Tools & Hardware',
        cosmetic: 'Cosmetics',
        leatherProducts: 'Leather Products',
        contrast: 'Compare',
        matting: 'Edit cutout',
        fullImage: 'Keep BG',
        select: 'Product type',
    },
    plugin: {
        hierarchy: {
            layer: 'Layer',
            title: 'Layer Management',
            back: 'Back',
            groupLayer: 'Group',
            mainLayer: 'Main image',
            backgroundLayer: 'Background',
            duplicate: 'Create a copy',
            delete: 'Delete',
            imageLayer: 'Images',
            vectorLayer: 'Graphics',
            tableLayer: 'Table',
            chartLayer: 'Chart',
            qrcodeLayer: 'QR code',
            watermarkLayer: 'Watermarks',
            draw: 'Brush',
            reupload: 'Replace',
            mattingOptimize: 'Optimize cutout',
            empty: 'No layers found',
        },
    },
    stage: {
        defaultText: 'Tap twice to edit text',
        viewImageInfo: 'Tap twice to replace image',
    },
    baseToolbar: {
        size: 'Size',
        width: 'W',
        height: 'H',
        lockRatio: 'Lock',
        customRatio: 'Customize ratio',
        position: 'Position',
        compose: 'Layout',
        angle: 'Angle',
        rotate90: 'Rotate 90°',
        flipHorizontal: 'Flip (H)',
        flipVertical: 'Flip (V)',
        alignLeft: 'Left alignment',
        alignCenter: 'Center horizontally',
        alignRight: 'Right alignment',
        alignTop: 'Top alignment',
        alignVertical: 'Vertical centering',
        alignBottom: 'Bottom alignment',
        vertical: 'Vertical',
        horizontal: 'Horizontal',
        dimension: 'Dimensions',
        adjust: 'Adjust',
        opacity: 'Opacity',
        sizeRange: 'Size',
        perspective: 'Perspective',
        deformation: 'Deformation',
        leftRotate: 'Rotate 90° left',
        rightRotate: 'Rotate 90° right',
    },
    headerToolbar: {
        replace: 'Replace',
        title: {
            group: 'Group',
            img: 'Images',
            text: 'Text',
            vector: 'Graphics/Text',
            table: 'Table',
            qrCode: 'QR code',
            brush: 'Lines',
            waterMark: 'Watermarks',
            media: 'Animations',
            chart: 'Chart',
            puzzle: 'Collage',
        },
        copyBtn: {
            copyText: 'Copy',
        },
        deleteBtn: {
            delText: 'Delete',
        },
        lockBtn: {
            lock: 'Lock',
            unLock: 'Unlock',
        },
        sortBtn: {
            index: 'Order',
            bottom: 'Bottom',
            top: 'Top',
            order: 'Order',
        },
        textBrushBtn: {
            copyStyle: 'Copy Style',
        },
    },
    chartLayer: {
        panel: {
            editData: 'Edit data',
            clearData: 'Clear data',
            typeSection: {
                name: 'Type',
                typeMap: {
                    'bar-basic': 'Column chart',
                    'bar-stacked': 'Stacked column chart',
                    'bar-horizontal-basic': 'Bar chart',
                    'bar-horizontal-stacked': 'Stacked bar chart',
                    'line-basic': 'Line chart',
                    'pie-basic': 'Pie chart',
                    'pie-doughnut': 'Donut chart',
                },
            },
            colorSection: {
                name: 'Color',
            },
            showSection: {
                name: 'Description',
                options: {
                    data: 'Data',
                    label: 'Label',
                    allAxis: 'X and Y coordinates',
                    axisAndTag: 'X coordinate and tag',
                    xAxis: 'X coordinate',
                    yAxis: 'Y coordinate',
                    legend: 'Legend',
                    top: 'Above',
                    bottom: 'Below',
                    left: 'Left',
                    right: 'Right',
                    gridLine: 'Grids',
                },
            },
            radius: 'Round corners',
            addOneRowOnAbove: 'Add one row above',
            addOneRowOnBelow: 'Add one row below',
            addOneColOnAbove: 'Add one column to the left',
            addOneColOnBelow: 'Add one column to the right',
            delete: 'Delete',
        },
        data: {
            series: 'Series',
            item: 'Item',
        },
        emptyChart: 'No data available',
    },
    qualityPanel: {
        apply: 'Image Enhancer',
        general: 'General',
        qualitySceneTitle: 'Scene',
        qualitySceneSubTitle: 'Scenario-optimized processing delivers professional-grade clarity.',
        hd: 'HD',
        hdu: 'UHD',
        hdSubTxt: 'Original',
        sd: 'SD',
        aiHud: 'AI UHD',
        aiHudSubTxt: 'Smartly enhances image details for sharper visuals.',
        product: 'Product',
        text: 'Text',
        portrait: 'Portrait',
    },
};
